export default __webpack_public_path__ + "static/media/1081.9dd58f99.png";